class LoadMore extends HTMLElement {
  constructor() {
    super();
    this._button = this.querySelector('button');
    this._paginateUrlsContainer = document.querySelector('[paginate-urls-container]');
    this._pageCount = parseInt(
      this._paginateUrlsContainer?.querySelector('.paginate-urls')?.getAttribute('data-page-count') || 1
    );
    this._occupiedSlots = parseInt(
      this._paginateUrlsContainer?.querySelector('.paginate-urls')?.getAttribute('data-occupied-slots') || 0
    );
    this._currentPage = parseInt(
      this._paginateUrlsContainer?.querySelector('.current_page')?.getAttribute('part') || 1
    );
    this._nextPage = this._currentPage + 1;
    this._nextPageUrl =
      this._paginateUrlsContainer?.querySelector(`.paginate-url[part="${this._nextPage}"]`)?.getAttribute('value') ||
      null;
    this._isLoading = false;
    this._productGrid = document.querySelector('#product-grid');
    this._collectionTemplate = document.querySelector('main');
    this._productCount = this.querySelector('#product-count');
    this._collectionTemplate.classList.add('transition-opacity', 'opacity-0');
    this._handleClick = this._handleClick.bind(this);
    this._manageOccupiedSlots();
    this._updateProductCount();
  }
  connectedCallback() {
    this._collectionTemplate.classList.remove('opacity-0');
    this._button.addEventListener('click', this._handleClick);
    this._updatePaginateUrls();
  }

  _handleClick() {
    this.expandShowMore();
  }

  _toggleLoadMoreButton() {
    this._button.classList.toggle('d-none', this._currentPage >= this._pageCount);
  }

  _updatePaginateUrls() {
    this._currentPage = parseInt(
      this._paginateUrlsContainer?.querySelector('.current_page')?.getAttribute('part') || 1
    );
    this._nextPage = this._currentPage + 1;
    this._nextPageUrl =
      this._paginateUrlsContainer?.querySelector(`.paginate-url[part="${this._nextPage}"]`)?.getAttribute('value') ||
      null;
    this._isLoading = false;
    this._toggleLoadMoreButton();
    this._toggleLoadingButton();
  }

  _toggleLoadingButton() {
    this._button.classList.toggle('btn--loading', this._isLoading);
  }

  _updateProductCount() {
    const productCards = Array.from(this._productGrid.children).filter(
      (child) => !child.classList.contains('d-none') && child.querySelector('card-product')
    );
    this._productCount.textContent = productCards.length;
  }

  _manageOccupiedSlots() {
    const allProductCards = Array.from(this._productGrid.querySelectorAll('card-product'));
    allProductCards.forEach((card) => card.closest('.grid__item').classList.remove('d-none'));
    if (this._occupiedSlots <= 0) return;
    const toHiddenProductCards = allProductCards.slice(-this._occupiedSlots);
    if (toHiddenProductCards.length > 0 && this._currentPage < this._pageCount) {
      toHiddenProductCards.forEach((card) => {
        card.closest('.grid__item').classList.add('d-none');
      });
    }
  }

  async expandShowMore() {
    if (this._isLoading) return;
    this._isLoading = true;
    this._toggleLoadingButton();
    if (!this._nextPageUrl) return;
    const response = await fetch(this._nextPageUrl);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const productGrid = html.querySelector('#product-grid');
    const products = productGrid.children;
    Array.from(products).forEach((product) => {
      this._productGrid.appendChild(product);
    });
    this._paginateUrlsContainer = html.querySelector('[paginate-urls-container]');
    this._updatePaginateUrls();
    this._manageOccupiedSlots();
    this._updateProductCount();
  }
}

customElements.define('load-more', LoadMore);
